<template>
  <span>
    <!-- TARJETA DE ESTADO DEL APARATO -->
    <v-card v-if="estadoAparato" class="tarjeta" :class="claseTarjeta" width="100%" max-width="420" :ripple="false" @contextmenu="mostrarMenu" @click="clickTarjetaAparato">
      <v-card-text class="pa-2">
        <!-- titulo  {{estadoAparato.long_name}}  -->
        <h3 v-if="iconosGrandes" class="mb-1">{{objetoAparato.des}}</h3>
        <h4 v-else class="mb-1">{{objetoAparato.des}}</h4>

        <!-- medidor de carga de tickets  -->
        <div style="position: relative">
          <MedidorCargaTickets v-if="estadoAparato.machine_type == 5" :carga="estadoAparato.tickets_load_level" style="position: absolute; top: -4px;"/>
        </div>

        <!-- imagen -->
        <img v-if="ficheroImagenEstadoActual" class="imagen-aparato d-block" :src="ficheroImagenEstadoActual" />

        <!-- matricula y nº de producto -->
        <div v-show="estadoAparato.recognized_license_plate" class="matricula">{{estadoAparato.recognized_license_plate}}</div>
        <div v-show="estadoAparato.last_product_number" class="numero-producto">{{estadoAparato.last_product_number}}</div>

        <!-- icono de estado de barrera -->
        <v-icon v-show="estadoAparato.barrier_status == 4" class="estado-barrera" color="#1991e3" :large="iconosGrandes">mdi-arrow-up-bold</v-icon>
        <v-icon v-show="estadoAparato.barrier_status == 2" class="estado-barrera" color="#f39800" :large="iconosGrandes">mdi-arrow-up-bold</v-icon>
        <v-icon v-show="estadoAparato.barrier_status == 5" class="estado-barrera" color="#1991e3" :large="iconosGrandes">mdi-arrow-down-bold</v-icon>
        <v-icon v-show="estadoAparato.barrier_status == 3" class="estado-barrera" color="#df5349" :large="iconosGrandes">mdi-boom-gate-alert</v-icon>

        <!-- otros indicadores -->
        <template v-if="[5, 6, 8].includes (estadoAparato.machine_type)">
          <v-icon v-show="estadoAparato.no_tickets_status" class="sin-tickets" color="#df5349" :large="iconosGrandes">mdi-file-alert</v-icon>
          <v-icon v-show="estadoAparato.lpr_error" class="error-lpr" color="orange" :large="iconosGrandes">mdi-camera-off</v-icon>
          <div v-show="!estadoAparato.parking_sign_forced && estadoAparato.parking_sign_full_active" class="cp-completo"><v-icon dark class="mr-1">mdi-close-octagon</v-icon>{{ $t ('Completo') }}</div>
          <div v-show="estadoAparato.parking_sign_forced && estadoAparato.parking_sign_full_active" class="cp-forzado cp-forzado-completo">*{{ $t ('Completo') }}*</div>
          <div v-show="estadoAparato.parking_sign_forced && !estadoAparato.parking_sign_full_active" class="cp-forzado cp-forzado-libre">*{{ $t ('Libre') }}*</div>
        </template>
        <template v-if="estadoAparato.machine_type == 7">
          <v-icon v-show="estadoAparato.safeGet ('devices.printer.end_of_paper')" class="sin-papel" color="orange" :large="iconosGrandes">mdi-paper-roll-outline mdi-flip-h</v-icon>
          <div v-show="[10, 11].includes (estadoAparato.operation_mode)" class="importe-restante">{{ $utilI18N.cadenaImporte (estadoAparato.payment_pending_amount) }}</div>
        </template>
        <template v-if="estadoAparato.machine_type == 6">
          <div v-show="estadoAparato.exits_mode == 1" class="ms ms-congestion-tp">{{ $t ('Congestión (TP)') }}</div>
          <div v-show="estadoAparato.exits_mode == 2" class="ms ms-congestion-tt">{{ $t ('Congestión (TT)') }}</div>
          <div v-show="estadoAparato.exits_mode == 3" class="ms ms-apertura-auto">{{ $t ('Apertura auto.') }}</div>
        </template>
        <div v-show="estadoAparato.out_of_order" class="fuera-de-servicio">{{ $t ('Fuera de servicio') }}</div>
        <div v-show="!estadoAparato.out_of_order && estadoAparato.exact_amount" class="importe-exacto">{{ $t ('Importe exacto') }}</div>

        <!-- {{estadoAparato}} -->
        <!-- {{objetoAparato}} -->
        <!-- {{ficheroImagenEstadoActual}} -->
      </v-card-text>
    </v-card>

    <!-- MENU CONTEXTUAL  -->
    <v-menu
      v-if="$store.operador.atributosRol.includes ('conremapa')"
      ref="menuContextual"
      v-model="menuVisible"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      z-index="9"
    >
      <v-list dense>
        <template v-if="objetoAparato.id_disint && $listeners['evento-asistencia-remota']">
          <v-list-item link @click="menuAsistenciaRemota">
            <v-list-item-icon class="mr-3"><v-icon color="#49af53">mdi-face-agent</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Asistencia remota') }}</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>
        </template>

        <template v-if="estadoAparato && [5, 6, 8].includes (estadoAparato.machine_type)">
          <v-list-item link @click="menuVentanaGestionAparato">
            <v-list-item-icon class="mr-3"><v-icon>mdi-folder-information</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Gestión de poste') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuAbrir" :disabled="estadoAparato.barrier_status == 2">
            <v-list-item-icon class="mr-3"><v-icon color="#659567">mdi-boom-gate-arrow-up</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Abrir barrera') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuCerrarBarrera" :disabled="estadoAparato.barrier_status == 2">
            <v-list-item-icon class="mr-3"><v-icon color="#df5349">mdi-arrow-down</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Cerrar barrera') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuIdentificarMatriculaManualmente" :disabled="!(estadoAparato && estadoAparato.column_loop_detection == 1)">
            <v-list-item-icon class="mr-3"><v-icon>mdi-eye-check</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Identificar matrícula manualmente') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-show="estadoAparato.barrier_status != 2" link dense @click="menuBloquearBarrera">
            <v-list-item-icon class="mr-3"><v-icon color="#dfa369">mdi-upload-lock</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Bloquear barrera') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-show="estadoAparato.barrier_status == 2" link dense @click="menuDesbloquearBarrera">
            <v-list-item-icon class="mr-3"><v-icon>mdi-download</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Desbloquear barrera') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuFuncionAuxiliar">
            <v-list-item-icon class="mr-3"><v-icon color="#b0b0b0">mdi-electric-switch</v-icon></v-list-item-icon>
            <v-list-item-title>{{ estadoAparato ? estadoAparato.auxiliary_relay_description : '' }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuReiniciarLecturaTAG">
            <v-list-item-icon class="mr-3"><v-icon color="#b0b0b0">mdi-credit-card-wireless-outline mdi-rotate-90</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Reiniciar lectura TAG') }}</v-list-item-title>
          </v-list-item>

          <template v-if="estadoAparato && [6].includes (estadoAparato.machine_type)">
            <v-menu offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item link v-bind="attrs" v-on="on">
                  <v-list-item-icon class="mr-3"><v-icon color="#b04242" class="mt-2">mdi-car-multiple</v-icon></v-list-item-icon>
                  <v-list-item-title>{{ $t ('Modo salidas') }}</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-menu-right</v-icon></v-list-item-action>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item link @click="menuModoSalidasNormal">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-boom-gate-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>Normal</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="menuModoSalidasCongestionTP">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-boom-gate-arrow-up-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>Congestión (TP)</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="menuModoSalidasCongestionTT">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-boom-gate-alert-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>Congestión (TT)</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-if="estadoAparato && [5].includes (estadoAparato.machine_type)">
            <v-menu offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item link v-bind="attrs" v-on="on">
                  <v-list-item-icon class="mr-3"><v-icon color="#4242b0" class="mt-2">mdi-alpha-p-box</v-icon></v-list-item-icon>
                  <v-list-item-title>{{ $t ('Cartel Completo') }}</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-menu-right</v-icon></v-list-item-action>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item link @click="menuCartelCompletoAutomatico">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-alpha-a-circle-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>Automático</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="menuCartelCompletoLibreForzado">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-alpha-l-circle</v-icon></v-list-item-icon>
                  <v-list-item-title>LIBRE (Forzado)</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="menuCartelCompletoCompletoForzado">
                  <v-list-item-icon class="mr-3"><v-icon>mdi-alpha-c-circle</v-icon></v-list-item-icon>
                  <v-list-item-title>COMPLETO (Forzado)</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-list-item link @click="menuExpenderTicket">
              <v-list-item-icon class="mr-3"><v-icon>mdi-redo</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t ('Expender ticket') }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-divider></v-divider>

          <v-menu offset-x>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link v-bind="attrs" v-on="on">
                <v-list-item-icon class="mr-3"><v-icon>mdi-valve</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t ('Vía') }}</v-list-item-title>
                <v-list-item-action><v-icon>mdi-menu-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item link @click="menuHabilitarVia">
                <v-list-item-icon class="mr-3"><v-icon>mdi-valve-open</v-icon></v-list-item-icon>
                <v-list-item-title>Habilitar</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="menuDeshabilitarVia">
                <v-list-item-icon class="mr-3"><v-icon>mdi-valve-closed</v-icon></v-list-item-icon>
                <v-list-item-title>Deshabilitar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-if="estadoAparato && [7].includes (estadoAparato.machine_type)">
          <v-list-item link @click="menuVentanaGestionAparato">
            <v-list-item-icon class="mr-3"><v-icon>mdi-folder-information</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Gestión de cajero') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuGestionTicketPerdido">
            <v-list-item-icon class="mr-3"><v-icon color="#b5b080">mdi-help-box</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Gestionar ticket perdido') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="menuImprimirReciboCobro">
            <v-list-item-icon class="mr-3"><v-icon color="#b0b0b0">mdi-file-outline</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Imprimir recibo de cobro') }}</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="estadoAparato && [5, 6, 7, 8].includes (estadoAparato.machine_type)">
          <v-menu offset-x>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link v-bind="attrs" v-on="on">
                <v-list-item-icon class="mr-3"><v-icon class="mt-2">mdi-traffic-light</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t ('Modo de servicio') }}</v-list-item-title>
                <v-list-item-action><v-icon>mdi-menu-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item link @click="menuDesactivarFueraServicio">
                <v-list-item-icon class="mr-3"><v-icon>mdi-motion-play-outline</v-icon></v-list-item-icon>
                <v-list-item-title>En servicio</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="menuActivarFueraServicio">
                <v-list-item-icon class="mr-3"><v-icon>mdi-close-octagon</v-icon></v-list-item-icon>
                <v-list-item-title>Fuera de servicio</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-list-item link @click="menuReiniciarAparato">
            <v-list-item-icon class="mr-3"><v-icon color="#4953df">mdi-restart</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Reiniciar aparato') }}</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="estadoAparato && [9].includes (estadoAparato.machine_type)">
          <v-list-item link @click="menuAbrir">
            <v-list-item-icon class="mr-3"><v-icon color="#659567">mdi-arrow-right-box</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t ('Abrir') }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <template v-if="estadoAparato && [5, 6, 8].includes (estadoAparato.machine_type)">
      <!-- DIALOGO DE IDENTIFICACION MANUAL DE MATRICULA -->
      <v-dialog v-model="dialogoMatriculaVisible" scrollable max-width="500">
        <v-card elevation="4">
          <v-card-title style="background-color: #90D0F0;">
            <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-eye-check</v-icon>
            {{ $t ('Identificación manual de matrícula') }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              ref="campoMatricula"
              class="mt-6"
              v-model="matricula"
              label="Matrícula"
              prepend-inner-icon="mdi-car"
              hide-details
              v-inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }"
              @keypress.enter="aceptarDialogoMatricula"
            >
            </v-text-field>
          </v-card-text>
          <v-card-actions class="mt-n1">
            <v-spacer />
            <v-btn text color="green darken-2" @click="aceptarDialogoMatricula">{{ $t ('Aceptar') }}</v-btn>
            <v-btn text color="black lighten-2" @click="dialogoMatriculaVisible = false">{{ $t ('Cancelar') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO DE APERTURA MANUAL DE BARRERA -->
      <VentanaAperturaManualBarrera ref="ventanaAperturaBarrera" />
    </template>
  </span>
</template>

<script>
import { DateTime } from "luxon";
import MedidorCargaTickets from "@/components/MedidorCargaTickets";
import VentanaAperturaManualBarrera from "@/components/VentanaAperturaManualBarrera";

export default {
  components: {
    MedidorCargaTickets,
    VentanaAperturaManualBarrera,
  },
  props: {
    objetoAparato: Object,
    objetoEstados: Object,
    objetoUltimasIncidencias: Object,
    sagabroker: Object,
    iconosGrandes: {
      type: Boolean,
      default: true,
    },
    ventanaGestionPoste: Object,
    ventanaGestionCajero: Object,
    ventanaSeleccionCobroParaImprimir: Object,
    ventanaGestionTicketPerdido: Object,
  },
  data() {
    return {
      menuVisible: false,
      x: 0,
      y: 0,
      momentoUltimoClick: 0,

      dialogoMatriculaVisible: false,
      matricula: '',

      dialogoAperturaBarreraVisible: false,
      motivoAperturaBarrera: '',
    }
  },
  methods: {
    clickTarjetaAparato() {
      let x = DateTime.fromMillis (this.momentoUltimoClick).diffNow('milliseconds').milliseconds * -1;
      this.momentoUltimoClick = DateTime.now().toMillis();
      if (x < 350)
        this.menuVentanaGestionAparato();
    },
    mostrarMenu(e) {
      e.preventDefault();
      this.menuVisible = false;

      if (!this.$store.operador.atributosRol.includes ('conremapa'))
        return;

      this.$parent.$emit ('antesAbrirMenu', this._uid);
      this.x = e.clientX;
      this.y = e.clientY;

      if (!this.estadoAparato.on_line)
        return;

      this.$nextTick(() => {
        this.menuVisible = true;
      })
    },
    ejecutarAccionAparato (accion, extra) {
      this.sagabroker.ejecutarAccionAparato (this.objetoAparato.id_ins, this.$store.operador.correoElectronico, this.objetoAparato.id_tipapa, this.objetoAparato.num, accion, extra);
    },
    menuAsistenciaRemota (){
      this.$emit ("evento-asistencia-remota", this.objetoAparato);
    },
    menuVentanaGestionAparato () {
      if (this.ventanaGestionPoste && [5, 6, 8].includes (this.estadoAparato.machine_type))
        this.ventanaGestionPoste.abrirVentana (this.objetoAparato, this.estadoAparato, this.sagabroker);
      else if (this.ventanaGestionCajero && this.estadoAparato.machine_type == 7)
        this.ventanaGestionCajero.abrirVentana (this.objetoAparato, this.estadoAparato, this.sagabroker);
    },
    menuImprimirReciboCobro () {
      this.ventanaSeleccionCobroParaImprimir.abrirVentana (this.objetoAparato, this.sagabroker);
    },
    menuGestionTicketPerdido () {
      this.ventanaGestionTicketPerdido.abrirVentana (this.objetoAparato, this.sagabroker);
    },
    menuAbrir (){
      let datosContextoAperturaManual = {};
      if (this.objetoAparato.id_tipapa == 9) { // Abrepuertas / postes abrepuertas
        this.sagabroker.ejecutarAccionAparato (this.objetoAparato.id_ins,
                                              this.$store.operador.correoElectronico,
                                              this.objetoAparato.id_tipapa,
                                              this.objetoAparato.num,
                                              'abrir_barrera',
                                              null);
      } else {
        this.sagabroker.solicitarDatosContextoAperturaManual (this.objetoAparato.id_ins, this.objetoAparato.id_tipapa, this.objetoAparato.num)
          .then ((respuesta) => {
            datosContextoAperturaManual = respuesta.contenido;
          })
          .catch (() => {
            datosContextoAperturaManual.matricula = this.estadoAparato.recognized_license_plate;
          })
          .finally (() => {
            this.$refs.ventanaAperturaBarrera.mostrar (this.objetoAparato, datosContextoAperturaManual)
              .then ((datosApertura) => {
                this.sagabroker.ejecutarAccionAparato (this.objetoAparato.id_ins,
                                                      this.$store.operador.correoElectronico,
                                                      this.objetoAparato.id_tipapa,
                                                      this.objetoAparato.num,
                                                      datosApertura.resultado_autorizacion ? 'abrir_barrera_v2' : 'abrir_barrera',
                                                      datosApertura);
              });
          });
      }
    },
    menuCerrarBarrera (){
      this.ejecutarAccionAparato ('cerrar_barrera');
    },
    menuIdentificarMatriculaManualmente (){
      this.dialogoMatriculaVisible = true;
      this.matricula = this.estadoAparato.recognized_license_plate;
      setTimeout (() => {
        this.$refs['campoMatricula'].focus();
      }, 250);
    },
    menuBloquearBarrera (){
      this.ejecutarAccionAparato ('bloquear_barrera');
    },
    menuDesbloquearBarrera (){
      this.ejecutarAccionAparato ('desbloquear_barrera');
    },
    menuFuncionAuxiliar (){
      this.ejecutarAccionAparato ('funcion_auxiliar');
    },
    menuReiniciarLecturaTAG (){
      this.ejecutarAccionAparato ('reiniciar_lectura_tag');
    },
    menuExpenderTicket (){
      this.ejecutarAccionAparato ('expender_ticket');
    },
    menuCartelCompletoAutomatico (){
      this.ejecutarAccionAparato ('cartel_completo_automatico');
      this.$refs.menuContextual.isActive = false;
    },
    menuCartelCompletoLibreForzado (){
      this.ejecutarAccionAparato ('cartel_completo_libre_forzado');
      this.$refs.menuContextual.isActive = false;
    },
    menuCartelCompletoCompletoForzado (){
      this.ejecutarAccionAparato ('cartel_completo_completo_forzado');
      this.$refs.menuContextual.isActive = false;
    },
    menuModoSalidasNormal (){
      this.ejecutarAccionAparato ('cambiar_modo_salidas', { modo_salidas: 0 });
      this.$refs.menuContextual.isActive = false;
    },
    menuModoSalidasCongestionTP (){
      this.ejecutarAccionAparato ('cambiar_modo_salidas', { modo_salidas: 1 });
      this.$refs.menuContextual.isActive = false;
    },
    menuModoSalidasCongestionTT (){
      this.ejecutarAccionAparato ('cambiar_modo_salidas', { modo_salidas: 2 });
      this.$refs.menuContextual.isActive = false;
    },
    menuHabilitarVia (){
      this.ejecutarAccionAparato ('habilitar_via');
      this.$refs.menuContextual.isActive = false;
    },
    menuDeshabilitarVia (){
      this.ejecutarAccionAparato ('deshabilitar_via');
      this.$refs.menuContextual.isActive = false;
    },
    menuDesactivarFueraServicio (){
      this.ejecutarAccionAparato ('desactivar_fuera_servicio');
      this.$refs.menuContextual.isActive = false;
    },
    menuActivarFueraServicio (){
      this.ejecutarAccionAparato ('activar_fuera_servicio');
      this.$refs.menuContextual.isActive = false;
    },
    menuReiniciarAparato (){
      this.$cuadroDeDialogo.mostrarEx ({
        propsDialog: { width: "450px", maxWidth: "80%" },
        propsCard: { dark: false },
        titulo: {
          texto: 'Reiniciar aparato',
          estilo: "background: #FFB74D",
          icono: {
            nombre: "mdi-alert",
            large: true
          }
        },
        cuerpo: { mensajes: `Por favor, confirme que desea reiniciar el aparato "${this.estadoAparato.long_name}"` },
        acciones: {
          botones: [
            { identificador: 'REINICIAR', texto: this.$t ('Reiniciar'), props: { text: true, color: "orange" } },
            { identificador: 'CANCELAR', texto: this.$t ('Cancelar'), props: { text: true } }
          ]
        }
      }).then ((boton) => {
        if (boton.identificador == 'REINICIAR')
          this.ejecutarAccionAparato ('reiniciar_aparato');
      });
    },
    aceptarDialogoMatricula() {
      this.ejecutarAccionAparato ('especificar_matricula_identificada', { matricula: this.matricula } );
      this.dialogoMatriculaVisible = false;
    },
    aceptarDialogoAperturaBarrera() {
      this.dialogoAperturaBarreraVisible = false;
      if (this.estadoAparato.machine_type == 9)
        this.ejecutarAccionAparato ('abrir_paso', { observaciones: this.motivoAperturaBarrera });
      else
        this.ejecutarAccionAparato ('abrir_barrera', { observaciones: this.motivoAperturaBarrera });
    },
  },
  computed: {
    codigoAparato() {
      return this.objetoAparato.cod;
    },
    claseTarjeta () {
      let res = '';
      if (this.menuVisible)
        res += ' zoom-activo';
      else
        res += ' zoom';
      if (!this.estadoAparato.on_line)
        res += ' aparato-offline';
      if (this.objetoUltimasIncidencias && this.objetoUltimasIncidencias [this.codigoAparato])
        res += ' indicador-incidencia'
      return res;
    },
    estadoAparato () {
      return this.objetoEstados [this.codigoAparato];
    },
    ficheroImagenEstadoActual() {
      let f = '';

      if (this.estadoAparato) {
        switch (this.estadoAparato.machine_type) {
          case 4: f = f + 'man'; break;
          case 5: f = f + 'ent'; break;
          case 6: f = f + 'sal'; break;
          case 7: f = f + 'caj'; break;
          case 8: f = f + 'sal'; break;
          case 9:
            switch (this.objetoAparato.id_modapa) {
              case 92: f = f + 'pae'; break;
              case 93: f = f + 'pas'; break;
            default:
              f = f + 'ap';
            }
        }
        if ([5, 6, 8].includes (this.estadoAparato.machine_type)) {
          switch (this.estadoAparato.column_loop_detection) {
            case true:
              f = f + '_dp1'; break;
            case false:
            case undefined:
              f = f + '_dp0'; break;
          }
          switch (this.estadoAparato.barrier_loop_detection) {
            case true:
              f = f + '_db1'; break;
            case false:
            case undefined:
              f = f + '_db0'; break;
          }
          switch (this.estadoAparato.barrier_status) {
            case 0: // cerrada
            case 4: // abriendo
            case 3: // desconocido
            case undefined:
              f = f + '_b0'; break;
            case 1: // abierta
            case 2: // bloqueada
            case 5: // cerrando
              f = f + '_b1'; break;
          }
        }
        if (this.estadoAparato.machine_type == 7) {
          if (this.estadoAparato.main_door_closed === false)
            f = f + '_pa';
          else if ([1, 90].includes (this.estadoAparato.safeGet ('operation_mode', 1)))
            f = f + '_ci0';
          else
            f = f + '_ci1';
        }
        if (this.estadoAparato.machine_type == 9) {
          if (this.estadoAparato.passerby)
            f = f + '_p1';
          else
            f = f + '_p0';
          if (this.estadoAparato.door_open)
            f = f + '_pa1';
          else
            f = f + '_pa0';
        }
        f = process.env.VUE_APP_URL_BASE_FRONTEND + 'assets__static/aparatos/' + f + '.png';
        // console.log(f);
      }
      return f;
    }
  },
  mounted() {
    this.$parent.$on('antesAbrirMenu', uidComponente => {
        if (this._uid != uidComponente)
          this.menuVisible = false;
    });
  }
};
</script>

<style scoped>
.tarjeta {
  transition: transform .2s;
  user-select: none;
  background: white;
}
.zoom {
  --dummy-style: foo;
}
.zoom-activo {
  transform: scale(1.15);
  border: solid 1px #4020aa;
  z-index: 1;
}
.imagen-aparato {
  border: dotted 2px #E8EAF6;
  border-radius: 4px;
  width: 100%;
  height: auto;
  min-width: 132px;
  min-height: 102px;
}
.aparato-offline {
  filter: saturate(0%);
  opacity: 0.4;
}
.matricula {
  padding: 0px 6px 0px 6px;
  background-color: #fefff6;
  font-family: monospace;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: 0.7px;
  color: black;
  border-radius: 3px;
  border: solid 1px #888;
  position: absolute;
  left: 50%;
  bottom: 38px;
  transform: translate(-50%, 0);
}
.numero-producto {
  font-family: monospace;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: -0.6px;
  color: #00a;
  position: absolute;
  right: 20px;
  bottom: 14px;
  text-shadow: 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;
}
.estado-barrera {
  position: absolute;
  top: 36px;
  right: 8px;
}
.error-lpr {
  position: absolute;
  top: 38px;
  right: 48px;
}
.sin-tickets {
  position: absolute;
  top: 38px;
  left: 16px;
}
.sin-papel {
  position: absolute;
  top: 38px;
  right: 12px;
}
.fuera-de-servicio {
  position: absolute;
  top: 53%;
  left: 50%;
  color: white;
  font-weight: bolder;
  text-align: center;
  text-transform: uppercase;
  background-color: rgba(219, 33, 8, 0.842);
  transform: translate(-50%, -50%);
  opacity: 0.7;
  border-radius: 5px;
  padding: 2px 5px 2px 5px;
}
.cp-completo {
  position: absolute;
  top: 53%;
  left: 50%;
  color: white;
  font-weight: bolder;
  text-align: center;
  text-transform: uppercase;
  background-color: rgba(255, 109, 0, 0.842);
  transform: rotate(-5deg) translate(-50%, -50%);
  opacity: 0.9;
  border-radius: 5px;
  padding: 2px 5px 2px 5px;
}
.cp-forzado {
  position: absolute;
  top: 39px;
  left: 13px;
  color: white;
  font-weight: bolder;
  opacity: 0.9;
  border-radius: 5px;
  padding: 2px 5px 2px 5px;
}
.cp-forzado-completo {
  text-transform: uppercase;
  background-color: rgb(196, 62, 0);
}
.cp-forzado-libre {
  color: rgb(0, 153, 46);
}
.ms {
  position: absolute;
  top: 39px;
  left: 14px;
  font-weight: bolder;
  font-size: 13px;
}
.ms-congestion-tp {
  color: rgb(17, 150, 0);
}
.ms-congestion-tt {
  color: rgb(0, 56, 211);
}
.ms-apertura-auto {
  color: rgb(255, 0, 0);
}
.importe-exacto {
  position: absolute;
  top: 53%;
  left: 50%;
  color: rgba(235, 133, 0, 0.966);
  font-size: 8pt;
  font-weight: bolder;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  background-color: black;
  transform: translate(-50%, -50%);
  opacity: 0.7;
  border-radius: 5px;
  padding: 0px 5px 0px 5px;
}
.importe-restante {
  position: absolute;
  bottom: 24px;
  right: 22px;
  color: rgba(49, 80, 255, 0.966);
  font-size: 14pt;
  font-weight: bolder;
  text-align: right;
  white-space: nowrap;
  transform: translate(0%, -50%);
  text-shadow: 0px -2px #fff, 0px 2px 0 #fff, -2px 0px 0 #fff, 2px 0px 0 #fff, -2px -2px #fff, 2px -2px 0 #fff, 2px 2px 0 #fff, -2px 2px 0 #fff;
}
.indicador-incidencia {
  animation: animacion-indicador-incidencia 1s linear infinite;
}
@keyframes animacion-indicador-incidencia {
  20% {
    background: #FFF176;
    transform: scale(1.02);
  }
  75% {
    background: #FFFFFF;
    transform: scale(0.98);
  }
}
</style>